import React from "react";
import { useCookies } from "react-cookie";
import { useNavigate } from 'react-router-dom';

function Logout() {
    const [cookies,, removeCookie] = useCookies(['sessionID']);

    const navigate = useNavigate();

    const myfunction = e => {
        e.preventDefault();
        let formBody = [];
        let encodedKey = encodeURIComponent("sessionID");
        const apiUrl = "https://" + (import.meta.env.VITE_APIURL || 'api.krh1996.com') + "/auth/logout";
        let encodedValue = encodeURIComponent(cookies.sessionID);
        formBody.push(encodedKey + "=" + encodedValue);
        formBody = formBody.join("&");
        fetch(apiUrl, {
            method: 'POST',
            body: formBody,
            headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
        })
            .then(res => res.json())
            .then(json => {
                if (json.success || json.code === 0) {
                    removeCookie("sessionID", { path: '/', ...(location.hostname === 'krh1996.com' || location.hostname.endsWith('.krh1996.com') ? { domain: '.krh1996.com' } : {}) });
                    window.location.href = "/#/";
                }
            });
    }

    return (
        <button className="dropdown-item" onClick={myfunction}>
          Sign out
        </button>
    );
}

export default Logout;
